if (!customElements.get('minions-video')) {
  class MinionsVideo extends HTMLElement {
    connectedCallback() {
      if (this.player) return;

      this.playButton = this.querySelector('[data-minions-video-play]');
      this.plyrTarget = this.querySelector('[data-plyr-video]');

      if (!this.plyrTarget || typeof Plyr === 'undefined') return;

      const youtubeLoop = this.getAttribute('data-youtube-loop') === 'true';
      const html5Loop = this.getAttribute('data-html5-loop') === 'true';
      const posterUrl = this.getPosterUrl();

      const plyrOptions = {
        autoplay: false,
        resetOnEnd: false,
        muted: false,
        clickToPlay: false,
        loop: {
          active: html5Loop,
        },
        controls: [
          'play',
          'progress',
          'current-time',
          'duration',
          'mute',
          'volume',
          'fullscreen',
        ],
        tooltips: {
          controls: false,
          seek: false,
        },
        youtube: {
          loop: youtubeLoop ? 1 : 0,
          rel: 0,
          modestbranding: 1,
        },
        vimeo: {
          byline: false,
          portrait: false,
          title: false,
        },
      };

      if (posterUrl) {
        plyrOptions.poster = posterUrl;
      }

      this.player = new Plyr(this.plyrTarget, plyrOptions);

      this.player.on('play', () => {
        this.classList.add('is-playing');
      });

      if (this.playButton) {
        this.playButton.addEventListener('click', () => {
          this.player.play().catch(() => {});
        });
      }
    }

    getPosterUrl() {
      const mobileQuery = window.matchMedia('(max-width: 989px)');
      const mobilePoster = this.getAttribute('data-poster-url-mobile');
      const desktopPoster = this.getAttribute('data-poster-url');

      if (mobileQuery.matches && mobilePoster) {
        return mobilePoster;
      }

      return desktopPoster || mobilePoster;
    }

    disconnectedCallback() {
      if (this.player && typeof this.player.destroy === 'function') {
        this.player.destroy();
        this.player = null;
      }
    }
  }

  customElements.define('minions-video', MinionsVideo);
}
